import { MonsterConfig } from "../Monster";
import ConfigMobGenerator from "./ConfigMobGenerator";

export class Monsters {

    static AllMobs: MonsterConfig[];
    static Created: boolean = false;

    static preload(scene: Phaser.Scene) {
        let mainConfigFIle = 'configuration/Mobs.json';
        scene.load.json('mobsData', mainConfigFIle);
    }

    static create(scene: Phaser.Scene) {
        if (Monsters.Created) {
            return;
        }

        let mobsData = scene.cache.json.get('mobsData');
        Monsters.AllMobs = [];

        mobsData.Mobs.forEach(mob => {
            let mobConfig: MonsterConfig =
            {
                Name: mob.Name,
                Velocity: mob.Velocity,
                MaxHP: mob.MaxHP,
                ExperienceDrop: mob.ExperienceDrop,
                Damage: mob.Damage,
                MinimumGoldDrop: mob.MinimumGoldDrop,
                MaximumGoldDrop: mob.MaximumGoldDrop,
                Scale: mob.Scale,
                File: mob.File
            };

            Monsters.AllMobs.push(mobConfig);
        });
        Monsters.Created = true;
    }

}